import {
  MotifFormField,
  MotifIcon,
  MotifOption,
  MotifSelect,
} from "@ey-xd/motif-react";
import "./CustomPagination.scss";
import {
  IconoirNavArrowLeft,
  IconoirNavArrowRight,
  IconoirFastArrowLeft,
  IconoirFastArrowRight,
} from "@ey-xd/motif-icon";

type CustomPaginationProps = {
  currentpage: number;
  pageSize: number;
  onChangePageSize: (page: number) => void;
  disableNext?: boolean;
  pageSizeSelector: number[];
  onChangeNextPage?: () => void;
  onChangePreviousPage?: () => void;
  onChangeFirstPage?: () => void;
  onChangeLastPage?: () => void;
  totalRecords?: number;
};

export default function CustomPagination({
  currentpage,
  pageSize,
  onChangePageSize,
  pageSizeSelector,
  onChangeNextPage,
  onChangePreviousPage,
  onChangeFirstPage,
  onChangeLastPage,
  totalRecords = 1,
}: CustomPaginationProps) {
  if (totalRecords === 0) {
    return null;
  }
  const totalPages = Math.ceil(totalRecords / pageSize);

  return (
    <div className="pagination-row">
      <div className="left-row"></div>
      <div className="paginationPanel">
        <div className="select-label"> {`Show`}</div>
        <MotifFormField>
          <MotifSelect
            ariaLabelledBy="select-label"
            onChange={onChangePageSize}
            placeholder=""
            value={String(pageSize)}
          >
            {pageSizeSelector.map((size) => (
              <MotifOption key={String(size)} value={String(size)}>
                {String(size)}
              </MotifOption>
            ))}
          </MotifSelect>
        </MotifFormField>
        <nav
          aria-label="Pagination Navigation"
          role="navigation"
          className="motif-pagination"
          data-motif-pagination="true"
        >
          <ul className="motif-pagination-list">
            <li className="motif-pagination-item"></li>
            <li className="motif-pagination-item">
              <button
                title="Go to first page"
                type="button"
                className="motif-icon-button motif-icon-button-small"
                disabled={currentpage === 1 ? true : false}
                data-motif-icon-button="true"
                onClick={onChangeFirstPage}
              >
                <span className="motif-icon" title="" data-motif-icon="true">
                  <MotifIcon
                    iconFunction={IconoirFastArrowLeft}
                    title="Left"
                    size="24"
                  />
                </span>
              </button>
            </li>
            <li className="motif-pagination-item">
              <button
                title="Go to previous page"
                type="button"
                className="motif-icon-button motif-icon-button-small"
                disabled={currentpage === 1 ? true : false}
                data-motif-icon-button="true"
                onClick={onChangePreviousPage}
              >
                <span className="motif-icon" title="" data-motif-icon="true">
                  <MotifIcon
                    iconFunction={IconoirNavArrowLeft}
                    title="Left"
                    size="24"
                  />
                </span>
              </button>
            </li>
            <li className="motif-pagination-item current-page">
              {currentpage} / {totalPages}
            </li>
            <li className="motif-pagination-item">
              <button
                title="Go to next page"
                type="button"
                className="motif-icon-button motif-icon-button-small"
                disabled={currentpage === totalPages ? true : false}
                data-motif-icon-button="true"
                onClick={onChangeNextPage}
              >
                <span className="motif-icon" title="" data-motif-icon="true">
                  <MotifIcon
                    iconFunction={IconoirNavArrowRight}
                    title="Right"
                    size="24"
                  />
                </span>
              </button>
            </li>
            <li className="motif-pagination-item">
              <button
                title="Go to last page"
                type="button"
                className="motif-icon-button motif-icon-button-small"
                disabled={currentpage === totalPages ? true : false}
                data-motif-icon-button="true"
                onClick={onChangeLastPage}
              >
                <span className="motif-icon" title="" data-motif-icon="true">
                  <MotifIcon
                    iconFunction={IconoirFastArrowRight}
                    title="Right"
                    size="24"
                  />
                </span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
